import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Baggage } from '../../../../BaggageService/types';
import { PassengerLabels } from '../../../../Checkout/types';
import { getDifferentForReturnFlight } from '../../store/selector';
import BySegment from './BySegment/BySegment';
import AllFlight from './AllFlight/AllFlight';
import { getBaggageTab } from '../../store/selector';
import { Passenger, Segment } from '../../../types';

export interface Props {
	upgradeBaggages: Baggage[][];
	passengers: Passenger[];
	passengerLabels: PassengerLabels;
	segments: Segment[];
	mobileSelectedServiceId?: string;
	baggageTab?: string;
	valueAlign?: 'center' | 'right';
}

const BaggageBody: React.FC<Props> = props => {
	const isDifferentForReturnFlight = useSelector(getDifferentForReturnFlight);
	const baggageTab = useSelector(getBaggageTab);

	const filteredBaggage = useMemo(() => {
		if (baggageTab) {
			return props.upgradeBaggages.filter(baggage => baggage[0].rfics === baggageTab);
		}

		return props.upgradeBaggages;
	}, [props.upgradeBaggages, baggageTab]);

	const baggageProps: Props = {
		...props,
		upgradeBaggages: filteredBaggage,
		baggageTab,
		valueAlign: baggageTab ? 'right' : props.valueAlign
	};

	if (isDifferentForReturnFlight) {
		return <BySegment {...baggageProps} />;
	} else {
		return <AllFlight {...baggageProps} />;
	}
};

export default BaggageBody;
